<template>
  <div class="mainHeader">
    <el-row style="height:100%;vertical-align:middle;">
      <img :src="LOGO_icon" alt="" class="_logo_icon"/>
      <img :src="LOGO_title" alt="" class="_logo_title"/>

      <!-- <el-col :span="3">
        
      </el-col>
      <el-col :span="8">
      </el-col> -->
      <div style="float:right;margin:35px 40px 0 0; right: 130px; display:inline-block">
        <el-button type="text" class="header-button" > 欢迎您：{{ teleNum }}</el-button>
        <el-button type="text" class="header-button"> 特别提示</el-button>
        <el-button type="text" class="header-button" @click="_logout"> 退出</el-button>
      </div>
      <!-- <el-col :span="12" style="margin-top:50px;margin-bottom:-20px;text-align: right">
        <el-button type="text" class="header-button" > 欢迎您：{{ teleNum }}</el-button>
        <el-button type="text" class="header-button"> 特别提示</el-button>
        <el-button type="text" class="header-button" @click="_logout"> 退出</el-button>
      </el-col> -->
    </el-row>

    <el-dialog
      title="修改密码"
      :visible.sync="updatePasswordDialog"
      width="30%"
    >
      <el-form :model="formUpdatePassword">
        <el-form-item label="原密码" :label-width="formLabelWidth">
          <el-input v-model="formUpdatePassword.password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" :label-width="formLabelWidth">
          <el-input v-model="formUpdatePassword.newPassword"></el-input>
        </el-form-item>
        <el-form-item label="新密码" :label-width="formLabelWidth">
          <el-input v-model="formUpdatePassword.newPasswordConfirm"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
    <el-button @click="updatePasswordDialog = false">取 消</el-button>
    <el-button type="primary" @click="updatePasswordDialog = false">确 定</el-button>
  </div>
    </el-dialog>
  </div>
</template>

<script>

import { logout } from "../../api/userService"
import LOGO_icon from "../../assets/logo/HyperBio_icon.png"
import LOGO_title from "../../assets/logo/HyperBio_title.png"

export default {
  name: "client",
  props: {
    teleNum: String,
  },
  data() {
    return {
      LOGO_icon,
      LOGO_title,
      // name:"",
      updatePasswordDialog: false,
      formLabelWidth: "80px",
      formUpdatePassword: {
        password: "",
        newPassword: "",
        newPasswordConfirm: "",
      },
    };
  },
  methods:{
    _logout() {
      logout()
      .then( res => {
        if(res.success) {
          sessionStorage.removeItem('logintoken');
          this.$message({ message: "您已经成功退出", type: "success", });
          this.$router.push({path:'/'})
        }
        else{
          this.$message({
            message: res.description,
            type: "success",
          });
        }
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mainHeader {
  padding: 20px 0 20px 0;
  margin: 0;
  /* height: 146px; */
  line-height: 100%;
  position: relative; 
  vertical-align:middle;
  color: white;
  background: linear-gradient(to bottom, #206DB8 0%, #2D55A0 50%, #191E37 100% );
}

.submenu {
  float: right;
}
.header-button {
  margin-right: 20px;
  color:white;
}

._logo_icon{
  width: 200px;
  height: auto;
  display:inline-block;
}
._logo_title{
  width: 300px;
  height: auto;
  display:inline-block;
}
/* ._logo_icon, ._logo_title{
  width:100%;
  height:auto;
  opacity:1;
  display:inline-block;
} */
/* .header-button:last-child{
  margin-right:0;
} */
h1{
font-family:"华文行楷";
font-weight:"normal";
}


</style>
